/**
 * Multi-Select Component
 */

import { type App } from '~/app';

export default (app: App) => {
    app.logger.debug('[Stockland FE] Initialise Stockland Multi Select Component');

    const listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]> = [];

    app.afterMount
        .then(() => {
            mountLocationBox(listeners);
        })
        .catch((error) => {
            throw new Error('[Stockland FE] Unable to register Stockland Multi Select Field Component', error);
        });

    return function destroySelectFormField() {
        unMountLocationBox(listeners);

        app.logger.debug('[DXA] Multi Select Field Component destroyed');
    };
};

export function mountLocationBox(
    listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]>,
    root: HTMLElement | null = null
) {
    let rootNode: Document | HTMLElement = document;
    if (root) rootNode = root;
    const currentToolTips = rootNode.querySelectorAll<HTMLElement>('.location-box-tooltip');
    for (const currentToolTip of currentToolTips) {
        const toolTipLabel= currentToolTip.querySelector<HTMLElement>('.tooltip-label');
        const currentTrigger= currentToolTip.querySelector<HTMLElement>('.tooltip-trigger');
        if(toolTipLabel && currentTrigger){
            currentTrigger.addEventListener('click',()=> {
                toolTipLabel.classList.toggle("opacity-0")
            })
            currentTrigger.addEventListener('mouseout',()=> {
                toolTipLabel.classList.add("opacity-0");
            })

            currentTrigger.addEventListener('mouseover',()=> {
                toolTipLabel.classList.remove("opacity-0");
            })
       
            listeners.push([currentTrigger,'mouseover', ()=> toolTipLabel.classList.remove(" opacity-0")], [currentTrigger,'mouseout', ()=> toolTipLabel.classList.add(" opacity-0")],[toolTipLabel,'click', ()=>  toolTipLabel.classList.toggle("opacity-0")]); 
        }
    }
}

export function unMountLocationBox(
    listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]>
) {
    for (const [element, event, listener] of listeners) {
        element.removeEventListener(event, listener);
    }
}
